// extracted by mini-css-extract-plugin
export default {"imgContain":"RN","content":"SN","titleAndImage":"TN","title":"UN","text":"VN","rhodeTitle":"WN","shortHR":"XN","modal_root":"YN","x_mark":"ZN","flavorStickModal":"aO","greenBox":"bO"};
    if(module.hot) {
      // 1715632478270
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  